import { render, staticRenderFns } from "./CommitteeDistribution.vue?vue&type=template&id=0d494e4d&scoped=true"
import script from "./CommitteeDistribution.vue?vue&type=script&lang=js"
export * from "./CommitteeDistribution.vue?vue&type=script&lang=js"
import style0 from "./CommitteeDistribution.vue?vue&type=style&index=0&id=0d494e4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d494e4d",
  null
  
)

export default component.exports